import React, { type FormEventHandler, useState } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';

type SectionLabelDialogProps = {
  onClose: () => void;
  onSubmit: (label: string) => void;
  title: string;
  disabled: boolean;
  submitLabel: string;
  initialValue: string;
};

export default function SectionLabelDialog({
  disabled,
  onClose,
  onSubmit,
  title,
  submitLabel,
  initialValue,
}: SectionLabelDialogProps) {
  const [label, setLabel] = useState(initialValue);
  const handleClose = () => {
    onClose();
  };

  const handleSubmit: FormEventHandler<HTMLFormElement> = (ev) => {
    ev.preventDefault();
    onSubmit(label);
  };

  return (
    <Dialog open onClose={disabled ? undefined : handleClose} fullWidth maxWidth="xs">
      <form onSubmit={handleSubmit}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <TextField
            disabled={disabled}
            margin="normal"
            autoFocus
            fullWidth
            label="Section label"
            placeholder="e.g. Onboarding"
            value={label}
            onChange={(ev) => setLabel(ev.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button disabled={disabled} onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button disabled={disabled && label.trim().length === 0} type="submit" color="primary" variant="contained">
            {submitLabel}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
